import { BackIcon } from '@psl/appComponents/BackIcon';
import { FontFamily } from '@psl/components/styles/Colors';
import { UserFrontContextProvider } from '@psl/flows/me/common/components/UserFrontContext';
import {
  userFrontScreens,
  UserFrontScreensParams,
} from '@psl/flows/me/screens';
import { useCurrentUserProfile } from '@psl/functions/auth/utils';
import {
  spreadScreens,
  wrapNavigatorScreen,
} from '@psl/functions/navigation/utils/wrapNavigatorScreen';
import { useResponsiveContext } from '@psl/functions/responsive/ResponsiveContext';
import { createStackNavigator } from '@react-navigation/stack';

const Stack = createStackNavigator<UserFrontScreensParams>();

export const UserFrontFlow = wrapNavigatorScreen(
  () => {
    const { rpx } = useResponsiveContext();
    const profile = useCurrentUserProfile();

    return (
      <UserFrontContextProvider profile={profile ?? undefined}>
        <Stack.Navigator
          initialRouteName="main"
          screenOptions={{
            detachPreviousScreen: false,
            headerBackTitle: ' ',
            headerTitleAlign: 'center',
            headerBackImage: () => <BackIcon fill={'#fff'} />,
            headerStyle: {
              backgroundColor: 'dark',
              borderBottomWidth: 0,
              shadowColor: 'transparent',
              shadowOpacity: 0,
              shadowRadius: 0,
            },
            headerTitleStyle: FontFamily.semiBold({
              fontSize: rpx(14),
              color: '#fff',
            }),
            cardStyle: {
              flex: 1,
              backgroundColor: '#000000',
            },
          }}
        >
          {spreadScreens(Stack.Screen, userFrontScreens, 'main')}
        </Stack.Navigator>
      </UserFrontContextProvider>
    );
  },
  { headerShown: false },
);
